var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 18C12.3284 18 13 18.6716 13 19.5C13 20.3284 12.3284 21 11.5 21C10.6716 21 10 20.3284 10 19.5C10 18.6716 10.6715 18 11.5 18Z",
    fill: "#535E70"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 11C12.3284 11 13 11.6715 13 12.5C13 13.3284 12.3284 14 11.5 14C10.6716 14 10 13.3284 10 12.5C10 11.6716 10.6715 11 11.5 11Z",
    fill: "#535E70"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 4C12.3284 4 13 4.67155 13 5.5C13 6.32845 12.3284 7 11.5 7C10.6716 7 10 6.32845 10 5.5C10 4.67155 10.6715 4 11.5 4Z",
    fill: "#535E70"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionIcon);
export default __webpack_public_path__ + "static/media/action_icon.a40f65c3f336b862661c0c4b9a79293c.svg";
export { ForwardRef as ReactComponent };